import React, { Component } from 'react';
import ParameterErrors from '../errors/ParameterErrors';
import stopEventPropagation from '../ui_core/stopEventPropagation';
import Marzipano from 'marzipano';
import View360 from '../360_react/View360';
import MiniMap from './MiniMap';
import './SitePlan360.css';
import { faCaretRight, faCaretLeft, faCaretUp, faCaretDown} from '@fortawesome/free-solid-svg-icons';
import IconButton from './IconButton';
import eventEnable from '../core/eventEnable';
import HashSource from '../core/HashSource';
import GroupedCallbacks from '../core/GroupedCallbacks';
import HotspotType from '../enums/HotspotType';
import InfoHotspot from '../hotspots/InfoHotspot';
import Handles from '../core/Handles';
import Spinner from './Spinner';
import Hider from './Hider';
import Urls from '../urls/Urls';
import EulerAngles from '../geometry/EulerAngles';
import AssetsManager from '../assets_management/AssetsManager';
import Tutorials from '../tutorials/Tutorials';
import TutorialMessage from '../tutorials/TutorialMessage';
const{throwNotProvided}=ParameterErrors;
const TWO_PI = Math.PI*2;
export default class SitePlan360 extends Component {
	constructor(props){
		super(props);
		eventEnable(this);
		const {getInsertedMenuItemsHandler, getInsertedMenuItemsAtEndHandler, onBack, goToConfigurator, 
			showPlotMenu, showPlotDetailedInformation, configuration, hidePlotMenu}=props;
		this._configuration = configuration;
		if(!getInsertedMenuItemsHandler)throwNotProvided('getInsertedMenuItemsHandler');
		if(!getInsertedMenuItemsAtEndHandler)throwNotProvided('getInsertedMenuItemsAtEndHandler');
		this._showPlotMenu = showPlotMenu;
		this._hidePlotMenu = hidePlotMenu;
		window.hidePlotMenu= hidePlotMenu;
		this._showPlotDetailedInformation = showPlotDetailedInformation;
		this._view360Ref = React.createRef();
		this._miniMapRef= React.createRef();
		this._buttonExitRef= React.createRef();
		//this._iframeRef = React.createRef();
		this.state = {visible:false};
		this._handleClickBack= this._handleClickBack.bind(this);
		this._normalizeRadians= this._normalizeRadians.bind(this);
		this._updateDoneWithTutorial= this._updateDoneWithTutorial.bind(this);
		this._callbackBack = onBack;
		this._callbackGoToConfigurator = goToConfigurator;
		this._getIconUrlFromRelativePath = this._getIconUrlFromRelativePath.bind(this);
		this._handleClickHotspot= this._handleClickHotspot.bind(this);
		this._handleToggleMinimap= this._handleToggleMinimap.bind(this);
		this.setVisible= this.setVisible.bind(this);
		this._getCameraDirectionEulerAngles = this._getCameraDirectionEulerAngles.bind(this);
		this.whenLoaded = this.whenLoaded.bind(this);
		this._sceneMoved = this._sceneMoved.bind(this);
		this._spinnerHandles = new Handles();
		this._create_SwitchToOutside360_LexicalClosure = this._create_SwitchToOutside360_LexicalClosure.bind(this);
		this._getInsertedMenuItemsHandler = getInsertedMenuItemsHandler;
		this._getInsertedMenuItemsAtEndHandler = getInsertedMenuItemsAtEndHandler;
		this._groupedCallbacksLoaded = new GroupedCallbacks();
		this._insertedMenuItemsRemoveHandle = null;
		this._insertedMenuItemsAtEndRemoveHandle = null;
		this._mapHotspotTypeToFactory={[HotspotType.INFO]:InfoHotspot.create};
		window._sitePlan360 = this;
		Tutorials.addEventListener('nOutside360HotspotsClickedChanged', this._updateDoneWithTutorial);
	}
	load(siteJson){
		this._siteJson = siteJson;
		this._loaded = false;
		return new Promise((resolve, reject)=>{
			if(!siteJson.outside360)
			{
				resolve();
				return;
			}
			this._view360Ref.current.loadScene({scene360:siteJson.outside360.getDefaultScene()}).catch(reject).then(()=>{
				this._switchToOutside360 = this._create_SwitchToOutside360_LexicalClosure(siteJson).bind(this);
				this._miniMapRef.current.load({
					siteJson:siteJson
				})
				.then(()=>{
					this._loaded=true;
					this._groupedCallbacksLoaded.doThen();
				}).catch((err)=>{
					this._groupedCallbacksLoaded.doCatch(err);
					reject(err);
				});
			});
			resolve();
		});
	}
	whenLoaded(){
		return new Promise((resolve, reject)=>{
			if(this._loaded)
			{
				resolve();
				return;
			}
			this._groupedCallbacksLoaded.then(resolve).catch(reject);
		});
	}
	switchToOutside360(outside360UniqueId, cameraDirectionEulerAngles){
		const spinnerHandle = this._spinnerHandles.take();
		return new Promise((resolve, reject)=>{
			const doReject = (err)=>{
				console.error(err);	
				spinnerHandle.dispose();
				reject(err);
			};
			this.whenLoaded().then(()=>{
				const doResolve=()=>{
					spinnerHandle.dispose();
					resolve();
				};
				if(!this._switchToOutside360){
					doReject(new Error('no scene loaded'));
					return;
				}
				this._switchToOutside360(outside360UniqueId, cameraDirectionEulerAngles)
					.then(doResolve).catch(doReject);
			}).catch(doReject);
		});
	}
	_create_SwitchToOutside360_LexicalClosure(siteJson){
		const scenes = siteJson.outside360.getScene360s();
		return (outside360ToMoveToUniqueId, cameraDirectionEulerAngles)=>{
			return new Promise((resolve, reject)=>{
				const scene = scenes.filter(scene=>{
						return scene.uniqueId===outside360ToMoveToUniqueId
				})[0];
				if(scene===undefined||scene===null)
					throw new Error(`No scene for outside360ToMoveToUniqueId ${outside360ToMoveToUniqueId}`);
				if(!cameraDirectionEulerAngles)
					cameraDirectionEulerAngles = this._getCameraDirectionEulerAngles(scene, this._previousScene);	
				this._previousScene=scene;
				this._miniMapRef.current.setAtOutside360(outside360ToMoveToUniqueId);
				this._view360Ref.current.loadScene({
					scene360:scene, 
					cameraDirectionEulerAngles:cameraDirectionEulerAngles
				})
				.then(()=>{
					resolve();
				}).catch(reject);
			});
		};
	}
	_getCameraDirectionEulerAngles(scene360, previousScene360){
		const otherScenesNotCountingOneCameFrom = [];
		const hotspotsForScene = scene360.hotspots;
		let yawRadianss = [];
		let hadNoOutside360MoveHotspots=true;
		let previousHotspot = null;
		if(!previousScene360)return null;
		for(var i=0; i<hotspotsForScene.length; i++){
			const hotspot = hotspotsForScene[i];
			if(hotspot.type!==HotspotType.OUTSIDE_360_MOVE)continue;
			if(previousScene360){
				if(hotspot.outside360ToMoveToUniqueId===previousScene360.uniqueId){
					previousHotspot = hotspot;
					continue;
				}
			}
			hadNoOutside360MoveHotspots=false;
			yawRadianss.push(hotspot.pointingAtEulerAngles.yawRadians);
		}
		let yawRadians =0;
		if(hadNoOutside360MoveHotspots){
			if(!previousHotspot)return null;
			yawRadians= previousHotspot.eulerAngles.yawRadians 
		}
		else{			
			yawRadianss.forEach(y=>{
				const normalized = this._normalizeRadians(y);
				yawRadians+=normalized;
			});
			yawRadians = yawRadians/yawRadianss.length;
		}
		if(previousHotspot&&yawRadianss.length>1){
			let directionOfTravel = this._normalizeRadians(Math.PI+previousHotspot.eulerAngles.yawRadians);
			let differenceInDirectionOfTravelAndYawRadians = yawRadians- directionOfTravel;
			differenceInDirectionOfTravelAndYawRadians = Math.sign(differenceInDirectionOfTravelAndYawRadians)*differenceInDirectionOfTravelAndYawRadians;
			if(differenceInDirectionOfTravelAndYawRadians>Math.PI/2)
				yawRadians = yawRadians+Math.PI;
		}
		return new EulerAngles({yawRadians:yawRadians, pitchRadians:0, rollRadians:0});
	}
	_normalizeRadians(value){
			value = value%TWO_PI;
			while(value<0)value+=TWO_PI;
			return value;
	}
	setVisible(value){
		//this._iframeRef.current.src='about:blank';
		//setTimeout(()=>{
		//this._iframeRef.current.src="http://futurium.tech/Clients/vX922Pvm/VistryGroup/FletcherRise360/ExternalV3/" ;
		//}, 0);
		this._insertedMenuItemsRemoveHandle?.dispose();
		this._insertedMenuItemsRemoveHandle = null;
		this._insertedMenuItemsAtEndRemoveHandle?.dispose();
		this._insertedMenuItemsAtEndRemoveHandle=null;
		if(value){
			let backClassName = "site-plan-360-back-button";
			if(this._backBeenClicked)
				backClassName+=" been-clicked";
			this._insertedMenuItemsRemoveHandle =
			this._getInsertedMenuItemsHandler().registerMenuItems([
					(<IconButton className={backClassName}
					ref={this._buttonExitRef}
					imgUrl ={Urls.assets+'icons/UI_Button_Exit.png'}
					onClick={this._handleClickBack} key={HashSource.next()}></IconButton>)
				]
			);
			this._insertedMenuItemsAtEndRemoveHandle = this._getInsertedMenuItemsAtEndHandler().registerMenuItems([
					(<IconButton className="site-plan-360-show-minimap-button" imgUrl ={Urls.assets+'icons/UI_Button_Filter_Plot.png'} onClick={this._handleToggleMinimap} key={HashSource.next()} atEnd={true}></IconButton>)
				]
			);
		}
		this.setState({visible:value});
	}
    componentDidMount(){
        this._view360Ref.current.addEventListener('scenemoved', this._sceneMoved);
	}
	_sceneMoved(e){
		this._miniMapRef.current.setAngleRadians(e.yaw);
	}
	_handleClickBack(){
		Tutorials.returnedFromOutside360 = true;
		this._tutorialMessageExit?.dispose();
		this._tutorialMessageMoveAroundOutside360?.dispose();
		this._backBeenClicked = true;
		this._callbackBack();
	}
	_handleToggleMinimap(){
		const minimap = this._miniMapRef.current;
		minimap.toggleShowing();
	}
	_getIconUrlFromRelativePath(iconRelativePath){
		return Urls.assets+iconRelativePath;
	}
	_handleClickHotspot(hotspot){
		const {scene360Hotspot}=hotspot;
		switch(scene360Hotspot.type){
			case HotspotType.OUTSIDE_360_MOVE:
				this._switchToOutside360(scene360Hotspot.outside360ToMoveToUniqueId).then(()=>{}).catch(console.error);
				Tutorials.nOutside360HotspotsClicked+=1;
				this._tutorialMessageMoveAroundOutside360?.dispose();
				this.dispatchEvent({type:'clickedoutside360movehotspot', scene360Hotspot});
				break;
			case HotspotType.OUTSIDE_360_CONFIGURATOR:
				const configuration = this._configuration;
				if(configuration.showPanelOnClickOutside360ConfiguratorIcon){
					const siteJsonUnitPlot = this._siteJson.getPlotByNumber(scene360Hotspot.plotNumber)
					if(configuration.onClickPlotSelectionMenuEntryShowDetailedElseSmallPlotInfo){
						this._showPlotDetailedInformation(siteJsonUnitPlot);
						return;
					}
					this._showPlotMenu(siteJsonUnitPlot, false, hotspot.centerPosition);
					return;
				}
				this._callbackGoToConfigurator(scene360Hotspot.plotNumber);
				return;;
			default:
				throw new Error('Not implemented for type '+scene360Hotspot.type);
				
		}
	}		
	_updateDoneWithTutorial(recreateIfExists){
			if(this._tutorialMessageExit){
				if(!recreateIfExists)return;
				this._tutorialMessageExit.dispose();
			}
			if(Tutorials.showing&&this.state.visible&&(Tutorials.canShowReturnToAerialViewMessage)&&(!Tutorials.returnedFromOutside360)){
				this._tutorialMessageExit = new TutorialMessage({
					message:'Return to aerial view', elementOn:this._buttonExitRef.current._elementRef.current, 
					hasClose:true, callbackClose:()=>{
						Tutorials.showing = false;
						this._tutorialMessageExit.dispose();
					},
					fixInPlace:true
				});
				Tutorials.addShowingTutorialMessage(this._tutorialMessageExit);
			}
	}
	//<iframe ref={this._iframeRef} src="http://futurium.tech/Clients/vX922Pvm/VistryGroup/FletcherRise360/ExternalV3/" style={{width:'100%', height:'100%'}}></iframe>
		
	render() {
		this._tutorialMessageExit?.dispose();
		this._tutorialMessageMoveAroundOutside360?.dispose();
		setTimeout(()=>{
			this._tutorialMessageExit?.dispose();
			this._tutorialMessageMoveAroundOutside360?.dispose();
			if(Tutorials.showing&&this.state.visible&&!Tutorials.doneWithMoveAroundOutside360Message){
				
				this._tutorialMessageMoveAroundOutside360 = new TutorialMessage({
					top:'50px',
					callbackClose:()=>{
						this._tutorialMessageMoveAroundOutside360?.dispose();
					},
					message:'Click and drag to rotate and click arrows to move around!',
					buttons:[{text:'OK', callback:()=>{
						Tutorials.doneWithMoveAroundOutside360Message=true;
						this._tutorialMessageMoveAroundOutside360?.dispose();
					}}]
				});
				Tutorials.addShowingTutorialMessage(this._tutorialMessageMoveAroundOutside360);
			}
			this._updateDoneWithTutorial(true);
		});
		const className = 'site-plan-360 '+(this.state.visible?'visible':'');
		const hiderClassName='hider'+(this.state.hideBehindSpinner?' visible':'');
	return (<div className={className} onClick={this._hidePlotMenu}>
		<View360 ref={this._view360Ref} getIconUrlFromRelativePath={this._getIconUrlFromRelativePath} onClickHotspot={
			this._handleClickHotspot}
		mapHotspotTypeToFactory={this._mapHotspotTypeToFactory}>
			<MiniMap ref={this._miniMapRef} configuration={this._configuration}></MiniMap>
		</View360>
		<Hider handles={this._spinnerHandles}>
				<Spinner spinnerHandles={this._spinnerHandles}/>
			</Hider></div>);
	}
}
